import React, { useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./Components/Navbar/Navbar";
import ProfilePage from "./Components/Profile/ProfilePage";
import GoogleAnalytics from "./Components/Analytics/GoogleAnalytics";

import Write from "./Components/Write/Write"
import ReWrite from "./Components/Write/ReWrite"
import './App.css';
import './Utils/localStoragePatch';
import SessionDetail from "./Components/DSA/SessionDetail";
import SessionProblems from "./Components/DSA/SessionProblems";
import ProblemDetails from "./Components/DSA/ProblemDetails";
import EditorComponent from "./Components/CodeEditor/Editor";
import ImproveWeakAreas from "./Components/WeakAreas/ImproveWeakAreas";
import HomePageDashboard from "./Components/Home/HomePageDashboard";
import LandingPage from "./Components/Landing/LandingPage";
import NotesPage from "./Components/Blog/NotesPage";
import Explorer from "./Components/LldEditor/Explorer";
import TabsBar from "./Components/LldEditor/TabsBar";
import EditorPane from "./Components/LldEditor/EditorPane";
import OutputPanel from "./Components/LldEditor/OutputPanel";
import {EditorProvider} from "./Components/context/EditorProvider";
import LLDProblemsList from "./Components/LLD/LLDProblemsList";
import LLDProblemDetails from "./Components/LLD/LLDProblemDetails";
import HLDProblemsList from "./Components/HLD/HLDProblemsList";
import HLDProblemDetails from "./Components/HLD/HLDProblemDetails";
import DSAQuestions from "./Components/DSA/DSAQuestions";
import DiscussionList from "./Components/Discussion/DiscussionList";
import DiscussionDetail from "./Components/Discussion/DiscussionDetail";
import DeepDives from "./Components/DeepDives/DeepDives";

import PastSubmissions from "./Components/Home/PastSubmissions";
import { useAuth } from './hooks/useAuth';
import ErrorBoundary from "./Components/ErrorBoundary";
import LoginOverlay from "./Components/Authorization/LoginOverlay";

function App() {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const [id, setId] = useState(0);
  const [showLoginOverlay, setShowLoginOverlay] = useState(false);

  const setTheId = (id) => {
    setId(id);
  }

  const getTheId = () =>{
    return id;
  }


  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <div>
          <Router>
            <GoogleAnalytics />
            <div className="app-container">
              <Navbar logout={logout} setTheId={setTheId}/>

              <div>
                <Routes>
                <Route path="/" element={
                  <LandingPage />
                } />
                <Route path="/dashboard" element={
                  <HomePageDashboard isAuthenticated={isAuthenticated}/>
                } />
                
                {/* All Routes Now Accessible */}
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/write" element={<Write setTheId={setTheId} getTheId={getTheId} id={id} />} />
                <Route path="/rewrite" element={<ReWrite setTheId={setTheId} getTheId={getTheId} id={id} />} />
                <Route path="/myNotes" element={<NotesPage />} />
                <Route path="/session-details" element={<SessionDetail />} />
                <Route path="/session-problems" element={<SessionProblems />} />
                <Route path="/problem-details" element={<ProblemDetails />} />
                <Route path="/problem-details/:topic" element={<ProblemDetails />} />
                <Route path="/problem-statement" element={<EditorComponent />} />
                <Route path="/improve-weak-areas" element={<ImproveWeakAreas />} />
                <Route path="/:problemId/editor" element={
                  <EditorProvider>
                    <div className="app-container1">
                      <aside className="sidebar">
                        <Explorer />
                      </aside>
                      <main className="main-area">
                        <TabsBar />
                        <EditorPane />
                        <OutputPanel />
                      </main>
                    </div>
                  </EditorProvider>
                } />
                <Route path="/lld/:problemId/editor" element={
                  <EditorProvider>
                    <div className="app-container1">
                      <aside className="sidebar">
                        <Explorer />
                      </aside>
                      <main className="main-area">
                        <TabsBar />
                        <EditorPane />
                        <OutputPanel />
                      </main>
                    </div>
                  </EditorProvider>
                } />
                <Route path="/lld" element={<LLDProblemsList />} />
                <Route path="/lld/problem" element={<LLDProblemDetails />} />
                <Route path="/hld" element={<HLDProblemsList />} />
                <Route path="/hld/problem" element={<HLDProblemDetails />} />
                <Route path="/dsa" element={<DSAQuestions />} />
                <Route path="/deep-dives" element={<DeepDives />} />
                <Route path="/deep-dives/:slug" element={<DeepDives />} />
                <Route path="/discussions" element={<DiscussionList />} />
                <Route path="/discussions/:discussionId" element={<DiscussionDetail />} />
                <Route path="/past-submissions" element={<PastSubmissions />} />
                <Route path="/todays-question" element={<HomePageDashboard />} />
                <Route path="*" element={<LandingPage />} />
              </Routes>
            </div>
            {/*<Bottombar className="bottomBar"/>*/}
          </div>
        </Router>
        
        {/* Login Overlay */}
        {showLoginOverlay && (
          <LoginOverlay onClose={() => setShowLoginOverlay(false)} />
        )}
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
